// How the billing rows the API sends are read. Plan 76 never appears in billing history.
export const isListedSubscription = (subscription) => subscription.plan_id !== 76;

export const isTrialSubscription = (subscription) => subscription.payment_type === 0 && subscription.plan_id === 1;
